/*-------------------------------------------------------------------------------------------------------------------
* about:小方下的遥控的操作列表
* author:马兆铿
* date:2018-3-7
* -------------------------------------------------------------------------------------------------------------------*/
export const findTipsText = (deviceName, deviceId) => {
  let text = {
    tv: [
      {
        title: '开关',
        text: [
          {name: '打开电视'},
          {name: '关闭电视'}
        ],
      },
      {
        title: '音量调节',
        text: [
          {name: '电视声音调大一点'},
          {name: '电视声音调小一点'},
          {name: '电视设为静音'}
        ],
      },
      {
        title: '切换频道',
        text: [
          {name: '电视调到34频道'},
          {name: '电视调到XXXX频道', link: '/settings/channel/list/?deviceId=' + deviceId, desc: '立即添加常用频道'},
          {name: '电视调到下一个频道'},
          {name: '电视调到上一个频道'}
        ],
      }
    ],
    tvBox: [
      {
        title: '开关',
        text: [
          {name: '打开机顶盒'},
          {name: '关闭机顶盒'}
        ],
      },
      {
        title: '切换频道',
        text: [
          {name: '机顶盒调到34频道'},
          {name: '机顶盒调到XXXX频道', link: '/settings/channel/list/?deviceId=' + deviceId, desc: '立即添加常用频道'}
        ],
      },
    ],
    fan: [
      {
        title: '开关',
        text: [
          {name: '打开风扇'},
          {name: '关闭风扇'}
        ],
      },
      {
        title: '风速',
        text: [
          {name: '风扇风速调高一点'},
          {name: '风扇风速调低一点'}
        ],
      },
      {
        title: '摆风',
        text: [
          {name: '风扇设置为摆风'},
          {name: '风扇关闭摆风'}
        ],
      },
    ],
    air: [
      {
        title: '开关',
        text: [
          {name: '打开空调'},
          {name: '关闭空调'}
        ],
      },
      {
        title: '温度调节',
        text: [
          {name: '空调设成25度'},
          {name: '空调温度调高一点'},
          {name: '空调温度调低一点'},
        ],
      },
      {
        title: '模式控制',
        text: [
          {name: '空调换成制冷模式'},
          {name: '空调换成制热模式'},
          {name: '空调换成除湿模式'},
          {name: '空调换成送风模式'}
        ],
      },
      {
        title: '风速控制',
        text: [
          {name: '空调风速设为低风'},
          {name: '空调风速设为中风'},
          {name: '空调风速设为高风'},
          {name: '空调风速设成自动'},
        ],
      },
    ],
  };
  return text[deviceName];
};


// WEBPACK FOOTER //
// ./src/pages/device/xiaofang/Tips/tipsText.js